import { RimmEntityType } from '../data/rimmEntityEnums';

function getLimitByEntity(entity: RimmEntityType) {
  switch (entity) {
    case RimmEntityType.commodity:
      return 15;
    case RimmEntityType.port:
      return 100;
    default:
      return 1000;
  }
}

export default getLimitByEntity;
